module.exports = __webpack_public_path__ + "img/handYellow.8ae5263a.png";